import * as d3 from "d3"

// Support legacy build system.
window.d3 = d3;